export const schedule_options = [
  // { value: "Every 30 minutes", label: "Every 30 minutes" },
  { value: "Hourly", label: "Hourly" },
  // { value: "Every 3 hours", label: "Every 3 hours" },
  // { value: "Every 6 hours", label: "Every 6 hours" },
  { value: "Every 12 hours", label: "Every 12 hours" },
  { value: "Daily", label: "Daily" },
  { value: "Manual Cron", label: "Manual Cron" },
];

export const propagation_options = [
  { value: "ignore", label: "Ignore" },
  { value: "propagate_columns", label: "Propagate columns" },
  { value: "propagate_fully", label: "Propagate all changes" },
];
const config_ = {
  prod: {
    workos: {
      CLIENT_ID: process.env.REACT_APP_WORKOS_CLIENT_ID,
      AUTH_DOMAIN: process.env.REACT_APP_WORKOS_AUTH_DOMAIN,
    },
    url: {
      GOOGLE_CLIENT_ID:"1052331148909-rv54iiv6gc1h37h0tpus7iossj6dvddd.apps.googleusercontent.com",
      WORKFLOWS: process.env.REACT_APP_API_URL + "/workflows",
      AIRFLOW: process.env.REACT_APP_API_URL + "/airflow",
      OBSERVABILITY: process.env.REACT_APP_API_URL + "/observability",
      SQL_EDITOR_URL: process.env.REACT_APP_API_URL + "/sql_editor",
      DBT_URL: process.env.REACT_APP_API_URL + "/dbt",
      GIT_URL: process.env.REACT_APP_API_URL + "/git",
      TAPS_URL: process.env.REACT_APP_API_URL + "/taps",
      WEBAPP: process.env.REACT_APP_API_URL + "/webapp",
      METADATA: process.env.REACT_APP_API_URL + "/metadata",
      PUSH_URL: process.env.REACT_APP_API_URL + "/push",
      PUSH_URL_v2: process.env.REACT_APP_API_URL + "/pushv2",
      DWH_URL: process.env.REACT_APP_API_URL + "/dwh",
      AI_URL: process.env.REACT_APP_API_URL + "/ai",
      SMS_URL: process.env.REACT_APP_API_URL + "/sms",
      CC_WEB_URL: process.env.REACT_APP_CC_WEB_URL || process.env.REACT_APP_API_URL,
    },
  },
  dev: {
    workos: {
      CLIENT_ID:
        process.env.REACT_APP_WORKOS_CLIENT_ID ||
        "client_01KTNW46QBY5ZNRYVAKHJRPBY0",
      AUTH_DOMAIN: process.env.REACT_APP_WORKOS_AUTH_DOMAIN,
    },
    url: {
      AIRFLOW: "http://127.0.0.1:5000",
      WORKFLOWS: "http://127.0.0.1:5000",
      WEBAPP: "http://127.0.0.1:5000",
      TAPS_URL: "http://127.0.0.1:5000",
      PUSH_URL: "http://127.0.0.1:5000",
      PUSH_URL_v2: "http://127.0.0.1:5000",
      METADATA: "http://127.0.0.1:5000",
      SQL_EDITOR_URL: "http://127.0.0.1:5000",
      DBT_URL: "http://127.0.0.1:5000",
      OBSERVABILITY: "http://127.0.0.1:5000",
      GIT_URL: "http://127.0.0.1:5000",
      AI_URL: "http://127.0.0.1:5000",
      DWH_URL: "http://127.0.0.1:5000",
      SMS_URL: "http://127.0.0.1:5000",
      CC_WEB_URL: "http://127.0.0.1:8001",
      GOOGLE_CLIENT_ID:
        "1052331148909-rv54iiv6gc1h37h0tpus7iossj6dvddd.apps.googleusercontent.com",
    },
  },
};

export const config =
  process.env.NODE_ENV === "development" ? config_.dev : config_.prod;
